module.exports = __webpack_public_path__ + "img/checked-icon.8ad22ad1.svg";